module.exports = __webpack_public_path__ + "img/check-yellow.c698f426.svg";